import store from '../../store/index.js'
import axios from 'axios'
import {
  throwStatement,
} from '@babel/types'

export const consentRoutes = [

  {
    path: 'consents',
    component: () => import('../../components/consents/landing/Consents.vue'),
    children: [{
      name: 'consents',
      path: '',
      component: () => import('../../components/consents/landing/ViewConsent.vue'),
    },
    {
      name: 'createConsent',
      path: 'create',
      component: () => import('../../components/consents/create/CreateConsent.vue'),
      props: true,
    },
    {
      name: 'editConsent',
      path: ':id',
      component: () => import('../../components/consents/edit/EditConsent.vue'),
      props: true,
      beforeEnter: (to, from, next) => {
        if (store.getters.consent._id == undefined) {
          axios.get('/consents/' + to.params.id).then(result => {
            const consent = result.data
            consent.createdDate = new Date(consent.createdDate).toLocaleDateString('en-GB')
            axios.get('/forms/').then(result => {
              let data = result.data

              const forms = data.displayFormDTOList

              store.dispatch('setFormArray', forms)
              store.dispatch('setConsent', consent)
              next()
            })
          })
        } else {
          next()
        }
      },

    },
    ],
  },

]
